export const lang = ['en','zh','id','vi','ja','ko','th','hi','ar','ru','tr','pt','fr','my','az','bg','it','es'];

export const country = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antarctica","Antigua & Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia-Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central African Republic","Chad","Chile","China","Colombia","Comoros","Republic of the Congo","Cook Islands","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Estonia","Ethiopia","Falkland Islands","Fiji","Finland","France","French Guiana","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Ivory Coast","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mexico","Moldova","Monaco","Mongolia","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","North Korea","Norway","Oman","Pakistan","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Qatar","Reunion","Romania","Russia","Rwanda","Saint Lucia","Saint Vincent & Grenadines","Samoa","San Marino","Saudi Arabia","Senegal","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea","Spain","Sri Lanka","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Tajikistan","Taiwan","Tanzania","Thailand","Togo","Tonga","Trinidad & Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","British Virgin Islands","Yemen","Yugoslavia","Zambia","Zimbabwe","Channel Islands","Democratic Republic of the Congo","Eritrea","French Polynesia","Saint Kitts & Nevis","Turks & Caicos Islands","Serbia","Timor-Leste","Montenegro","Isle of Man","Palestinian Authority","Kosovo","Curaçao","Other","Guernsey","Offshore","Jersey","Niue"];

export const simpleIndustry = ["Energy Equipment and Services","Oil, Gas and Consumable Fuels","Chemicals","Construction Materials","Containers and Packaging","Metals and Mining","Paper and Forest Products","Aerospace and Defense","Building Products","Construction and Engineering","Electrical Equipment","Industrial Conglomerates","Machinery","Trading Companies and Distributors","Commercial Services and Supplies","Professional Services","Air Freight and Logistics","Airlines","Marine","Road and Rail","Transportation Infrastructure","Auto Components","Automobiles","Household Durables","Leisure Products","Textiles, Apparel and Luxury Goods","Hotels, Restaurants and Leisure","Diversified Consumer Services","Media","Distributors","Internet and Catalog Retail","Multiline Retail","Specialty Retail","Food and Staples Retailing","Beverages","Food Products","Tobacco","Household Products","Personal Products","Healthcare Equipment and Supplies","Healthcare Providers and Services","Health Care Technology","Biotechnology","Pharmaceuticals","Life Sciences Tools and Services","Banks","Thrifts and Mortgage Finance","Diversified Financial Services","Consumer Finance","Capital Markets","Insurance","Real Estate Investment Trusts (REITs)","Real Estate Management and Development","Internet Software and Services","IT Services","Software","Communications Equipment","Technology Hardware, Storage and Peripherals","Electronic Equipment, Instruments and Components","Semiconductors and Semiconductor Equipment","Diversified Telecommunication Services","Wireless Telecommunication Services","Electric Utilities","Gas Utilities","Multi-Utilities","Water Utilities","Independent Power and Renewable Electricity Producers"];

export const clientType = [
  'Internal',
  'Client',
  'Prospective Client',
  'Investor',
  'Prospective Investor',
  'Others',
];

export const clientSubscriptionType = [
  'byQuota',
  'payPerUse',
  'bankruptcyCheck',
  'pepChecks'
]
export const projectType = [
  'New profile',
  'Profile update',
  'Mapping',
  'Financials only',
  'Litigation',
  'Lite DD',
  'Risk-based protocol',
  'Rating only',
  'Translation',
  'Offline report',
]
export const source = ['drm','visi','acra', 'cap iq'];

export const qos = ['Media','Official','Leaked','Unconfirmed'];

export const gender = ['Female', 'Male'];


export const yesNo = ['yes', 'no'];

export const entityStatus = ['Active', 'Inactive', 'NA'];

export const legalForm = ['Private', 'Public'];

export const overallStatus = [
  'active', 'inactive', 'archived'
]
export const projectStatus = [
  '1. To be done',
  '2. Working',
  '3. Editor reviewing',
  `4. Addressing editor's comments`,
  '5. Uploaded and submitted',
  '6. All expenses recorded',
];

export const riskType = [
  'Under Investigation','Dictator-Linked','Penalised','Political Risk'
]

export const relType = [
  'Acquaintance',
  'Family',
  'Commercial',
  'Political',
  'Subsidiary',
  'Professional',
  'Shareholding',
  'Same'
];

export const relTypeMapping = {
  'Acquaintance': 101,
  'Family': 102,
  'Commercial': 103,
  'Political': 104,
  'Subsidiary': 105,
  'Professional': 106,
  'Litigation': 107,
  'Shareholding': 108,
  'Same': 109
}

export const decisionStatus = ['Accepted','Denied'];

export const sourceMapping = {
  101: 'DRM + Media',
  102: 'PADOS + Official',
  103: 'MIRA + Official',
  104: 'CAP IQ + Official',
  105: 'Panama Papers + Leaked',
  106: 'KCOM + Official',
  107: 'ACRA + Official',
  108: 'DRM + Official',
  109: 'DRM + Leaked',
  110: 'DRM + Unconfirmed',
  111: 'LinkedIn + Official',
  112: 'VISI + Official',
  113: 'VeriThai + Official',
  114: 'Bahamas Leaks + Leaked',
  115: 'Offshore Leaks + Leaked',
  117: 'WorldBox + Official',
  118: 'ICIJ Leaks + Unconfirmed',
  119: 'ICIJ Leaks + Leaked',
  120: 'Paradise Papers + Leaked',
  121: 'Forbes + Media',
  122: 'Hurun + Media',
  123: 'High Risk Entity List + Official',
  124: 'Liberty Asia + Official',
  125: 'C6 + Official'
}

export const sourceList =
  Object.keys(sourceMapping).map(key => sourceMapping[key]);
